var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailunread(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.242,
    height: 19.286,
    viewBox: "0 0 24.242 19.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-unread-outline",
    transform: "translate(-2.25 -4.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M17.412,6.75H5.44A2.065,2.065,0,0,0,3.375,8.815V21.2A2.065,2.065,0,0,0,5.44,23.265H22.714A2.065,2.065,0,0,0,24.779,21.2V14.13",
    transform: "translate(0 -0.596)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M7.875,11.25l7.431,5.78,4.49-3.389",
    transform: "translate(-1.197 -1.794)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M31.949,8.107a2.475,2.475,0,1,1-2.475-2.475A2.474,2.474,0,0,1,31.949,8.107Z",
    transform: "translate(-6.285 -0.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M29.179,11.108a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,29.179,11.108Zm0-4.949A1.651,1.651,0,1,0,30.827,7.81a1.651,1.651,0,0,0-1.649-1.651Z",
    transform: "translate(-5.987)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailunread);
export default __webpack_public_path__ + "static/media/mailunread.40b9666769303e231cdbe0366e8ca778.svg";
export { ForwardRef as ReactComponent };